<div class="card-header">
  <h2>Need assistance?</h2>
</div>

<div class="link-row">
  <div class="link-icon green">
    <mat-icon>support_agent</mat-icon>
  </div>
  <div class="link-content">
    <h4>Platform issue?</h4>
    <p>
      Don't wait -
      <button
        type="button"
        class="inline-link pl-link"
        (click)="openSupportChat()"
      >
        start a chat</button
      >.
    </p>
  </div>
</div>

<div class="link-row">
  <div class="link-icon teal">
    <mat-icon>event_note</mat-icon>
  </div>
  <div class="link-content">
    <h4>Office hours:</h4>
    <p>
      Need to get face to face with another clinician? Find some time in our
      <a
        href="https://calendly.com/kangaofficehours"
        target="_blank"
        rel="noopener noreferrer"
        >weekly office hours.</a
      >
    </p>
  </div>
</div>

<div class="link-row">
  <div class="link-icon facebook">
    <mat-icon>facebook</mat-icon>
  </div>
  <div class="link-content">
    <h4>Facebook Group</h4>
    <p>
      Join the clinical collaboration on
      <a
        href="https://www.facebook.com/groups/688197601802713"
        target="_blank"
        rel="noopener noreferrer"
        >Facebook.</a
      >
    </p>
  </div>
</div>
